import actionTypes from "../actions/actionTypes";

const initialState = {
  tenantName: null,
  isSidebarExapand: true,
  selectedLanguage: "en",
  myProfile: null,
  pageLoader: false,
  colors: {
    theme: null,
    green: "#7EFFAA",
    blushGreen: "#34FB69",
    darkGreen: "#1eb942",
    purple: "#A07EFF",
    red: "#FF7EB5",
    orange: "#FFC37E",
    darkOrange: "#FB9F34",
    lightOrange: "#D4B257",
    blue: "#4166F8",
    mattBlue: "#7E9BFF",
    lightBlue: "#43CFE5",
  },
  userRoleMenu: null,
  tenantPermissionsInfo: null,
};

const commonReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.commonTypes.SET_TENANT_NAME:
      return { ...state, tenantName: payload };
    case actionTypes.commonTypes.SIDEBAR_TOGGLE:
      return { ...state, isSidebarExapand: payload };
    case actionTypes.commonTypes.SET_LANGUAGE:
      return { ...state, selectedLanguage: payload };
    case actionTypes.commonTypes.SET_PAGE_LOADER:
      return { ...state, pageLoader: payload };
    case actionTypes.commonTypes.GET_MY_PROFILE:
      return { ...state, myProfile: payload };
    case actionTypes.commonTypes.UPDATE_MY_PROFILE:
      return { ...state, myProfile: payload };
    case actionTypes.commonTypes.RESET_PASSWORD:
      return { ...state, userPassword: payload };
    case actionTypes.commonTypes.SET_THEME_STYLES:
      return { ...state, colors: { ...state.colors, theme: payload } };
    case actionTypes.commonTypes.SET_USER_ROLE_MENU:
      return { ...state, userRoleMenu: payload };
    case actionTypes.commonTypes.GET_TENANT_PERMISSION_INFO:
      return { ...state, tenantPermissionsInfo: payload };
    default:
      return state;
  }
};

export default commonReducer;
